import React, { useState, useEffect, useRef } from "react";
import Typography from "../components/Typography";
import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";
import { fetchTickerNews } from "../models/marketsService";

import TickerNewsList from "./TickerNewsList";
import { franc } from "franc-min";


function TickerNewsManager ({ watchlist, newsArticles }){
    const [allNews, setAllNews] = useState([]);

    useEffect(() => {
        // if (!watchlist || !watchlist.stocks) return;
        
        // console.log("Current watchlist: ", watchlist);

        if (newsArticles && newsArticles.length > 0) {
          setAllNews(newsArticles); // ✅ Use news from props if available
          return;
        }
        

        const fetchAllNews = async () => {
          try {
              let combinedNews = [];
      
              // For each stock, fetch up to 3 news articles
              for (const symbol of watchlist.stocks) {
                  const response = await fetchTickerNews(symbol, 3);
                  if (response?.results?.length) {
                      combinedNews = [...combinedNews, ...response.results];
                  }
              }
      
              // ✅ Filter news where title is detected as English and length ≤ 60 characters
              const filteredNews = combinedNews
                  .filter(article => franc(article.title || "", { minLength: 3 }) === "eng")
                  .filter(article => article.title.length <= 60);
      
              // ✅ Sort descending by publish_utc
              filteredNews.sort((a, b) => new Date(b.publish_utc) - new Date(a.publish_utc));
      
              setAllNews(filteredNews);
          } catch (error) {
              console.error("Error fetching all ticker news:", error);
          }
      };
      
      fetchAllNews();

      }, [watchlist, newsArticles]);


    return (
        <div>
            <TickerNewsList tickerNews={allNews} />
        </div>
    )
}

export default TickerNewsManager;